import React from 'react';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { SchemaOf } from 'yup';
import { AuthSignInPayload } from 'modules/auth/domain/interfaces/AuthSignInPayload';
import UDFormInput from 'modules/ud-form/components/input';
import UDButton from 'modules/ud-ui/components/button';

type SignInFormProps = {
  initialValues: {
    username: string;
    password: string;
  };
  isLoading: boolean;
  onSubmit: (values: AuthSignInPayload) => void;
  validationSchema?: SchemaOf<AuthSignInPayload>;
};

const SignInForm = (props: SignInFormProps) => {
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={props.initialValues}
      onSubmit={props.onSubmit}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={props.validationSchema}
    >
      {(formProps) => (
        <form onSubmit={formProps.handleSubmit}>
          <UDFormInput
            name="username"
            label={t('signIn.phoneInputLabel')}
            placeholder={t('signIn.phoneInputPlaceholder')}
            containerProps={{ className: 'mb-6' }}
          />
          <UDFormInput
            autoComplete="off"
            name="password"
            type="password"
            label={t('signIn.passwordInputLabel')}
            placeholder={t('signIn.passwordInputPlaceholder')}
            containerProps={{ className: 'mb-10' }}
          />
          <UDButton
            variant="primary"
            type="submit"
            className="w-100 mb-3"
            loading={props.isLoading}
          >
            {t('signIn.signInButtonLabel')}
          </UDButton>
        </form>
      )}
    </Formik>
  );
};

export default SignInForm;
